/**
 * product-compare.js
 * Maxpro Fitness – Product Compare Feature
 */

(function () {
  'use strict';

  const MAX_PRODUCTS = 4;
  const STORAGE_KEY  = 'mxp_compare_products';

  /* ─── State ─────────────────────────────────────────────── */
  let products = [];

  function loadFromStorage() {
    try {
      products = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (e) {
      products = [];
    }
  }

  function saveToStorage() {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(products));
    } catch (e) {}
  }

  /* ─── Core Actions ───────────────────────────────────────── */
  function toggle(btn) {
    const id  = btn.dataset.compareId;
    const idx = products.findIndex(p => p.id === id);

    if (idx > -1) {
      products.splice(idx, 1);
    } else {
      if (products.length >= MAX_PRODUCTS) {
        showNotice('You can compare up to ' + MAX_PRODUCTS + ' products at a time.');
        return;
      }
      products.push(extractData(btn));
    }
    saveToStorage();
    updateUI();
  }

  function removeProduct(id) {
    products = products.filter(p => p.id !== id);
    saveToStorage();
    updateUI();
    if (products.length === 0) {
      closePopup();
    } else {
      renderPopupContent();
    }
  }

  function clearAll() {
    products = [];
    saveToStorage();
    updateUI();
    closePopup();
  }

  /* ─── Data Extraction ────────────────────────────────────── */
  function extractData(btn) {
    return {
      id:            btn.dataset.compareId,
      title:         btn.dataset.compareTitle,
      image:         btn.dataset.compareImage,
      url:           btn.dataset.compareUrl,
      price:         btn.dataset.comparePrice,
      comparePrice:  btn.dataset.compareComparePrice,
      available:     btn.dataset.compareAvailable === 'true',
      motor:         btn.dataset.compareMotor         || '',
      runningArea:   btn.dataset.compareRunningArea   || '',
      maxUserWeight: btn.dataset.compareMaxUserWeight || '',
      speedLevels:   btn.dataset.compareSpeedLevels   || '',
      foldable:      btn.dataset.compareFoldable       || '',
      warranty:      btn.dataset.compareWarranty       || '',
    };
  }

  /* ─── UI Updates ─────────────────────────────────────────── */
  function updateUI() {
    updateButtons();
    updateHeaderBadge();
    updateStickyBar();
  }

  function updateButtons() {
    document.querySelectorAll('.compare-add-btn').forEach(function (btn) {
      const isAdded = products.some(p => p.id === btn.dataset.compareId);
      btn.classList.toggle('is-added', isAdded);
      var label = btn.querySelector('.compare-btn-label');
      if (label) label.textContent = isAdded ? 'Remove' : 'Add to Compare';
    });
  }

  function updateHeaderBadge() {
    var badge = document.getElementById('compare-header-badge');
    if (!badge) return;
    badge.textContent = products.length;
    badge.style.display = products.length > 0 ? 'flex' : 'none';
    badge.setAttribute('aria-label', products.length + ' products to compare');
  }

  function updateStickyBar() {
    var bar = document.getElementById('compare-sticky-bar');
    if (!bar) return;

    if (products.length > 0) {
      bar.classList.add('is-visible');
    } else {
      bar.classList.remove('is-visible');
    }

    // Update floating badge count
    var floatCount = document.getElementById('compare-float-count');
    if (floatCount) floatCount.textContent = products.length;
  }

  /* ─── Popup ──────────────────────────────────────────────── */
  function openPopup() {
    if (products.length === 0) {
      showNotice('Add at least one product to compare.');
      return;
    }
    renderPopupContent();
    var overlay = document.getElementById('compare-popup-overlay');
    if (overlay) {
      overlay.classList.add('is-active');
      document.body.classList.add('compare-popup-open');
      // Trap focus
      var closeBtn = overlay.querySelector('.compare-popup-close');
      if (closeBtn) closeBtn.focus();
    }
  }

  function closePopup() {
    var overlay = document.getElementById('compare-popup-overlay');
    if (overlay) {
      overlay.classList.remove('is-active');
      document.body.classList.remove('compare-popup-open');
    }
  }

  function renderPopupContent() {
    var inner = document.querySelector('#compare-popup-overlay .compare-popup-inner');
    if (!inner) return;

    var fields = [
      { key: 'price',         label: 'Price' },
      { key: 'motor',         label: 'Motor' },
      { key: 'runningArea',   label: 'Running Surface' },
      { key: 'maxUserWeight', label: 'Max User Weight' },
      { key: 'speedLevels',   label: 'Max Speed' },
      { key: 'foldable',      label: 'Foldable' },
      { key: 'warranty',      label: 'Warranty' },
      { key: 'available',     label: 'Availability' },
    ];

    /* Product header columns */
    var headerCols = products.map(function (p) {
      return '<th class="compare-product-col">'
        + '<button class="compare-col-remove" onclick="CompareFeature.removeProduct(\'' + p.id + '\')" title="Remove from compare">'
        +   '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>'
        + '<a href="' + p.url + '" class="compare-col-image-link">'
        +   '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">'
        + '</a>'
        + '<a href="' + p.url + '" class="compare-col-title">' + p.title + '</a>'
        + '</th>';
    }).join('');

    /* Field rows */
    var rows = fields.map(function (field) {
      var cells = products.map(function (p) {
        var val;
        if (field.key === 'price') {
          val = '<span class="compare-price-now">' + p.price + '</span>';
          if (p.comparePrice && p.comparePrice !== p.price) {
            val += ' <s class="compare-price-was">' + p.comparePrice + '</s>';
          }
        } else if (field.key === 'available') {
          val = p.available
            ? '<span class="compare-in-stock">In Stock</span>'
            : '<span class="compare-out-stock">Out of Stock</span>';
        } else {
          val = p[field.key] ? p[field.key] : '<span class="compare-empty">—</span>';
        }
        return '<td class="compare-val-cell">' + val + '</td>';
      }).join('');
      return '<tr><td class="compare-label-cell"><strong>' + field.label + '</strong></td>' + cells + '</tr>';
    }).join('');

    /* View product row */
    var viewRow = '<tr class="compare-view-row"><td class="compare-label-cell"></td>'
      + products.map(function (p) {
          return '<td class="compare-val-cell">'
            + '<a href="' + p.url + '" class="compare-view-btn">VIEW PRODUCT</a>'
            + '</td>';
        }).join('')
      + '</tr>';

    inner.innerHTML =
      '<button class="compare-popup-close" onclick="CompareFeature.closePopup()" aria-label="Close comparison">'
      +   '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
      + '</button>'
      + '<h2 class="compare-popup-heading">Compare Products</h2>'
      + '<div class="compare-table-wrap">'
      +   '<table class="compare-table" role="table">'
      +     '<thead><tr><th class="compare-label-col"></th>' + headerCols + '</tr></thead>'
      +     '<tbody>' + rows + viewRow + '</tbody>'
      +   '</table>'
      + '</div>';
  }

  /* ─── Notice Toast ───────────────────────────────────────── */
  function showNotice(msg) {
    var existing = document.getElementById('compare-notice');
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.id = 'compare-notice';
    el.setAttribute('role', 'alert');
    el.textContent = msg;
    document.body.appendChild(el);
    setTimeout(function () { el.classList.add('is-visible'); }, 10);
    setTimeout(function () {
      el.classList.remove('is-visible');
      setTimeout(function () { el.remove(); }, 300);
    }, 3000);
  }

  /* ─── Event Listeners ────────────────────────────────────── */
  function init() {
    loadFromStorage();
    updateUI();

    /* Close popup on overlay click */
    document.addEventListener('click', function (e) {
      var overlay = document.getElementById('compare-popup-overlay');
      if (e.target === overlay) closePopup();
    });

    /* Close popup on Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closePopup();
    });

    /* Delegate compare button clicks on dynamically loaded content */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.compare-add-btn');
      if (btn) {
        e.preventDefault();
        toggle(btn);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ─── Public API ─────────────────────────────────────────── */
  window.CompareFeature = {
    toggle:        toggle,
    removeProduct: removeProduct,
    clearAll:      clearAll,
    openPopup:     openPopup,
    closePopup:    closePopup,
  };

})();
